// extracted by mini-css-extract-plugin
module.exports = {"video-player-module":"video_video-player-module__Ix7yJ","preview-image":"video_preview-image__2GXEZ","play-button":"video_play-button__1CLJo"};